import { h } from 'preact'
import withSearch from './withSearch'

function WithSearch({ mapContextToProps, children }) {
    const ChildrenWithSearchProps = withSearch(mapContextToProps)(props => {
        return children(props)
    })

    return <ChildrenWithSearchProps />
}

export default WithSearch
